import { Component, Input } from "@angular/core";
import {
  CommunityMembership,
  MembershipListConfig,
} from "../../../../../models";

@Component({
  selector: "membership-preview",
  templateUrl: "./membership-preview.component.html",
  styleUrls: [
    "./membership-preview.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class MembershipPreviewComponent {
  private defaultUserImg: string =
    "../../../../../../../assets/images/uMuzi/african-mask.png";
  @Input() query: MembershipListConfig;
  @Input() membership: CommunityMembership;
}
